<style lang="sass" scoped>
.dist-ctn
    ::v-deep .el-input
        width: 100%
        margin-bottom: 10px
        text-align: center
        border: 1px solid rgba(40,39,41,.2)
        input
            padding-left: 0

    .tree
        height: 360px
        overflow: auto
        overflow-x: hidden
        ::v-deep .el-checkbox
            position: relative
            top: -1px

.dist_input
    height: 28px
    overflow: hidden
    padding-left: 10px
    position: relative
    cursor: pointer

    .item-ctn
      width: 195px
      &.ellipse
        position: relative
        &::after
          position: absolute
          right: 8px
          top: 2px
          color: #c0c4cc
          font-size: 18px
          line-height: 1
          content: '...'
    > i
        position: absolute
        right: 10px
        top: 8px
        color: #c0c4cc
        line-height: 1

    .choose-item
        display: inline-block
        border-radius: 4px
        padding: 0 4px
        height: 28px
        line-height: 28px
        background: #F5F5F5
        font-size: 14px
        margin-right: 5px
        span
            color: #666
            font-size: 12px
        i
            cursor: pointer
            float: right
            margin-top: 1px
            margin-left: 5px
            color: #D4D4D4
            font-size: 14px
            &:hover
                color: #999
</style>

<template lang="pug">
el-popover(placement="bottom" trigger="click" popper-class="gg-dist form_pop" @hide="popHide" @show="isHide = false")
  .dist_input(slot="reference")
    .item-ctn(ref="itemCtn" :class="{'ellipse': isShowEllipsis}" :title="isShowEllipsis ? allNames : ''")
      span(v-if="chooseDist.length == 0" style="display: inline-block;color: #999;margin-top: 1px;") 请选择
      span(v-if="isWhole") 全国
      <template v-else>
        .choose-item(v-for="(item, i) in chooseDist" :key="i") {{item.name}}
          span(v-if="checkCodes.indexOf(item.guid + '') < 0 && item.children && item.children.length") ({{spread(item.children)}})
          i.iconfont.icon-shibai(@click="delChooseItem(item, i)")
      </template>
    i.el-icon-arrow-down(v-if="isHide")
    i.el-icon-arrow-up(v-else)

  .dist-ctn
    el-input(size="mini" placeholder="输入城市名称" v-model="curValue" @focus="show=true;notSearch=false" @blur="show=false;notSearch=true")
    .tree
      el-tree(
        ref="tree"
        icon-class="iconfont icon-biaodan-xuanzezhankai"
        show-checkbox
        size="mini"
        node-key="code"
        :data="cityArr"
        :props="{ children: 'children', label: 'districtValue' }"
        :default-checked-keys="checkCodes"
        :filter-node-method="filterNode"
        @check="chooseChange"
        @node-click="clickExpand")
        span.custom-tree-node(slot-scope="{ node, data }" style="display:flex;justify-content:space-between;width:100%;line-height:28px;padding-right:10px;")
          span
            img(v-if="data.levelNum<7" src="../assets/tree_icon_1.png")
            img(v-else-if="data.levelNum>7" src="../assets/tree_icon_3.png")
            img(v-else-if="data.levelNum==7" src="../assets/tree_icon_2.png")
            span(style="margin-left:8px;") {{node.label}}
</template>

<script>
export default {
  name: 'GgDistAsync',
  props: [ 'text', 'v', 'parentProp' ],
  data () {
    return {
      curValue: '',
      show: false,
      notSearch: true,
      filterNum: 1000,
      clickChooseData: null,
      chooseDistArr: [],
      checkCodes: [],
      chooseDist: [],
      isShowEllipsis: false,
      isHide: true,
      cityArr: [],
      searchTimer: null,
      oldStr: '',
      isWhole: false
    }
  },
  watch: {
    curValue (v) {
      v = v ? v.trim() : ''
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.$refs.tree.filter(v)
        // if ('全国'.indexOf(v) > -1) this.showWhole = true
        // else this.showWhole = false
      }, 200)
    }
  },
  computed: {
    spanClass () {
      if(this.show) return 'active'
      if(this.curValue.trim() != '') return 'active'
      else return ''
    },
    spread () {
      return data => {
        return data.length === 1 ? data[0].name : data.length + '个区'
      }
    },
    allNames () {
      return this.chooseDist.map(x => x.name).join('、')
    }
  },
  async created () {
    // 获取地区数据
    if(!this.storeGet('userDistTree')) await this.$store.dispatch('getUserDistTreeAll')
    this.cityArr = [
      {
        code: '',
        districtValue: '全国',
        names: '全国',
        children: this.$store.state.common.originUserDistTree || []
      }
    ]
    this.initHangZhou()
  },
  methods: {
    async searchTree (str, isWifi) {
      if (!str) return
      if (str == this.oldStr) return
      this.oldStr = str
      let res = await this.fetch('/config/api/v3/region/district', {
        districtValue: str,
        deviceCode: isWifi ? '83886336' : '33554688', // 屏-33554688，网关-83886336  投放城市搜索此处 网络广告投放 传 网关  其他都传屏
        levelNum: 4
      }, 'get')
      if (res && res.code == 0) return res.data || []
      return []
    },
    async clickExpand (data, node, vm) {
      if (data.levelNum > 3) return // 区级别点击不做请求处理
      if (!data.children || data.children.length === 0) {
        // 触发store里相关层级获取新增子集数据
        await this.$store.dispatch('reqDistTreeChild', data)
        // 从store里拿到当前数据和新的children列表
        let newCurData = this.$store.state.common.originUserDistTree.filter(el => el.code === data.code)[0]
        if (newCurData) {
          let children = newCurData.children || []
          data.children = children // 更新当前组件里的当前数据的children列表
          node.expanded = true // 展开当前的node
          this.$refs.tree.setCheckedKeys(this.$refs.tree.getCheckedKeys()) // 渲染新子集重新渲染下整体的选中状态
          this.chooseChange()
        }
      }
    },
    initHangZhou () {
      if (!this.cityArr || !this.cityArr.length || !this.cityArr[0].children) return
      if (this.cityArr[0].children.length === 1) {
        const one = this.cityArr[0].children[0]
        this.checkCodes = [one.code]
        this.chooseDist = [{ ...one, name: one.districtValue }]
      } else {
        // let hzIdx = this.cityArr[0].children.map(el => el.code).indexOf('330100')
        // if (hzIdx > -1) {
        //   this.checkCodes = ['330100']
        //   let hz = this.cityArr[0].children[hzIdx]
        //   this.chooseDist = [{...hz, name: hz.districtValue}]
        // } else {
        //   this.checkCodes = []
        //   this.chooseDist = []
        // }
        // 20230109 投放城市改为默认选中“全国”
        this.checkCodes = this.cityArr[0].children.map(e => e.code)
        this.chooseDist = this.cityArr[0].children.map(e => {
          e.name = e.districtValue
          e.children && e.children.length > 0 && e.children.forEach(cd => { cd.name = cd.districtValue })
          return e
        })
      }
      if (this.$refs.tree) {
        let treeComp = this.$refs.tree
        treeComp.setCheckedNodes(this.checkCodes)
        this.cityArr[0].children.forEach(data => {
          let node = treeComp.getNode(data)
          if (node && node.expanded) node.expanded = false
        })
      }
      this.$nextTick(() => {
        const ckNodes = this.$refs.tree.getCheckedNodes()
        this.isWhole = !!ckNodes.filter(e => e.districtValue === '全国')[0] // 是否选中全国
        this.handleEllipsis()
        this.$emit('change', ckNodes)
      })
    },
    topCheck (res) {
      let d = []
      let final = res.map(e => e.ids).sort()
      final.forEach(item => {
        d.forEach(e => {
          if ((item + '').indexOf(e) > -1) item = null
        })
        if (item) d.push(item + '')
      })
      return d
    },
    chooseChange (data) {
      // getCheckedNodes(p1, p2) p1:是否只是叶子节点,默认false, p2:是否包含半选节点,默认false
      let allChoose = this.$refs.tree.getCheckedNodes(false, true)
      let chooses = allChoose.map(el => {
        // 不拷贝下会直接改变原数据
        let each = JSON.parse(JSON.stringify(el))
        // 半选状态的子集可能包括所有的未勾选的子集，这里清空下子集
        each.children = []
        return each
      }).filter(el => el.levelNum == 3 || el.levelNum == 4)     // 只保留城市和区

      // 合并成一棵树，赋值给this.chooseDistArr
      // 排序，以防父级在子集的后面   排序后有毛病？？
      // let cps = JSON.parse(JSON.stringify(chooses))
      // levelNum 较小的等级高的放前面，方便重组，sort貌似存在异常，先分开再合并
      // let cps1 = cps.filter(el => el.levelNum == 3).concat(cps.filter(el => el.levelNum == 4))
      let tree = []
      let repeat = function(arr, el) {
        arr.forEach(each => {
          if(each.code == el.parentCode){
            if(!each.children) each.children = []
            each.children.push(el)
            el.isRepeat = true
          }else {
            each.children && repeat(each.children, el)
          }
        })
      }
      chooses.forEach(el => {
        if(el.isRepeat) return false
        if(tree.length == 0) {
          tree.push(el)
          el.isRepeat = true
        }else {
          repeat(tree, el)
          if(!el.isRepeat){
            tree.push(el)
            el.isRepeat = true
          }
        }
      })
      this.chooseDistArr = tree
      if(!this.chooseDistArr || this.chooseDistArr.length == 0) {
        this.chooseDist = []
      } else {
        this.chooseDist = this.chooseDistArr.map(el => {
          el.name = el.districtValue
          el.children && el.children.length > 0 && el.children.forEach(cd => { cd.name = cd.districtValue })
          return el
        })
      }

      const ckNodes = this.$refs.tree.getCheckedNodes()
      this.isWhole = !!ckNodes.filter(e => e.districtValue === '全国')[0] // 是否选中全国
      this.checkCodes = ckNodes.map(el => el.code)
      this.handleEllipsis()
      this.$emit('change', ckNodes)
      // /**
      //  * 2024-04-23 支持授权账号区域勾选临时方案(只授权城市下的某个区/县的情况)：
      //  * 若已勾选城市下面只有一个区/县,则搜索传参优先使用"区/县"行政编码
      //  *! 若授权一个城市下的多个区/县则传参仍会出现问题
      //  */
      // const countyFirst = ckNodes.map(e => {
      //   if (e.levelNum === 3 && e.children.length === 1) {
      //     return null
      //   }
      //   return e
      // }).filter(e => e) // 过滤空数据
      // this.$emit('change', countyFirst)
    },
    delChooseItem (item, i) {
      let codes = item.children ? item.children.map(el => el.code) : []
      codes.push(item.code)
      codes.forEach((el, j) => {
        let idx = this.checkCodes.indexOf(el)
        if (idx > -1) this.checkCodes[idx] = null
      })
      this.checkCodes = this.checkCodes.filter(el => el)

      this.$refs.tree.setCheckedKeys(this.checkCodes)
      this.chooseDist.splice(i, 1)

      const ckNodes = this.$refs.tree.getCheckedNodes()
      this.isWhole = !!ckNodes.filter(e => e.districtValue === '全国')[0] // 是否选中全国
      this.handleEllipsis()
      this.$emit('change', ckNodes)
    },
    handleEllipsis () {
      this.$nextTick(() => {
        if (this.$refs.itemCtn && this.$refs.itemCtn.clientHeight > 40) this.isShowEllipsis = true
        else this.isShowEllipsis = false
      })
    },
    filterNode (value, data) {
      if(!value) return true
      return data.names.indexOf(value) !== -1
    },
    popHide(){
      this.isHide = true
    }
  }
}
</script>

<style lang="scss">
.gg-dist.el-popover {
  margin-left: -85px;
  width: 320px;
  border: 1px solid #282729;
  z-index: 2000 !important;
  .el-input {
    input {
      text-align: center;
      border: none;
      padding-right: 0;
    }
  }
  .el-tree-node__expand-icon {
    position: absolute;
    right: 0;
  }
}
</style>
